exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/sass-loader/lib/loader.js??ref--2-2!./src/themes/base-theme.scss
// module id = 48
// module chunks = 0